import { createContext } from "preact";
import type { Global } from "../types/Global";

export const ContextGlobal = createContext<Global | undefined>(undefined);
